import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import './QueueAlreadyBooked.css';
import warningIcon from '../images/already.svg';

const QueueAlreadyBooked = () => {
  const { getText } = useLanguage();
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  
  const currentQueueData = location.state?.queueData;
  const queueCode = currentQueueData?.code || `000`;
  const serviceName = currentQueueData?.terminalService?.serviceName || 
                      currentQueueData?.terminalService?.service?.name ||
                      currentQueueData?.service?.name || 
                      getText('Ваши услуги', 'Хизматрасонии шумо');

  useEffect(() => {
    const duration = 6000;
    const intervalTime = 100;
    const step = (intervalTime / duration) * 100;

    const timer = setInterval(() => {
      setProgress((prev) => (prev >= 100 ? 100 : prev + step));
    }, intervalTime);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (progress >= 100) {
      const timeout = setTimeout(() => navigate('/services'), 500);
      return () => clearTimeout(timeout);
    }
  }, [progress, navigate]);

  return (
      <div className="qab-page-container">
        <main className="qab-main-content">
          {/* Корти асосӣ: width: 466, height: 526 */}
          <div className="qab-status-card">

            <div className="qab-top-section">
              <div className="qab-warning-icon">
                <img src={warningIcon} alt="warning" width="80" height="80" />
              </div>
              <h2 className="qab-main-title">{getText('Очередь уже забронирована', 'Навбат алакай қабул шудааст')}</h2>
            </div>

            <div className="qab-number-box">
              <div className="qab-badge">
                <span className="qab-badge-text">{getText('ВАШ НОМЕР', 'РАҚАМИ ШУМО')}</span>
              </div>
              <div className="qab-queue-code">{queueCode}</div>
              <p className="qab-sub-text">{serviceName}</p>
            </div>

          </div>
        </main>

        {/* Прогресс бар дар поён (Rectangle 944) */}
        <div className="progress-footer">
          <div className="progress-bar" style={{ width: `${progress}%` }}></div>
        </div>
      </div>
  );
};

export default QueueAlreadyBooked;